import type { SVGProps } from 'react'

export const LocalShippingFilledIcon = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M233.76-177.69q-46.84 0-79.53-32.76T121.54-290H90q-15.36 0-25.76-10.39-10.39-10.4-10.39-25.76v-381.54q0-30.31 21-51.31 21-21 51.3-21h472.31q29.83 0 51.07 21.24 21.24 21.24 21.24 51.07v80h70q17.17 0 32.54 7.68 15.36 7.68 25.3 21.24l100.31 134.31q3.62 4.52 5.43 9.94 1.8 5.43 1.8 11.75v116.62q0 15.36-10.39 25.76Q885.36-290 870-290h-36.15q0 46.79-32.79 79.55-32.78 32.76-79.61 32.76t-79.53-32.76q-32.69-32.76-32.69-79.55H346.15q0 46.92-32.78 79.61-32.78 32.7-79.61 32.7Zm.09-60q22 0 37.15-15.16Q286.15-268 286.15-290T271-327.16q-15.15-15.15-37.15-15.15t-37.16 15.15Q181.54-312 181.54-290q0 22 15.15 37.15 15.16 15.16 37.16 15.16Zm487.69 0q22 0 37.15-15.16Q773.85-268 773.85-290t-15.16-37.16q-15.15-15.15-37.15-15.15t-37.16 15.15Q669.23-312 669.23-290q0 22 15.15 37.15 15.16 15.16 37.16 15.16ZM670.77-430H850L750-562.69q-1.92-2.31-4.42-3.66-2.5-1.34-5.58-1.34h-69.23V-430Z" />
    </svg>
  )
}
